export default {
  submit: "Enviar",
  search: "Buscar",
  reset: "Restablecer",
  select: "Seleccionar",
  create: "Crear",
  update: "Actualizar",
  edit: "Editar",
  delete: "Eliminar",
  add: "Agregar",
  remove: "Eliminar",
  cancel: "Cancelar",
  save: "Guardar",
  saved: "Guardado",
  loading: "Cargando...",
  error: "Error",
  success: "Éxito",
  warning: "Advertencia",
  info: "Información",
  date: "Fecha",
  time: "Hora",
  today: "Hoy",
  yesterday: "Ayer",
  tomorrow: "Mañana",
  lastDays: "Últimos {days} días",
  upgrade: "Actualizar",
  import: "Importar",
  export: "Exportar",
  ok: "Aceptar",
  close: "Cerrar",
  clear: "Limpiar",
  retry: "Reintentar",
  upload: "Cargar",
  row: "Fila {row}",
  items: "elementos",
  yes: "Sí",
  no: "No",
  utc: "UTC",
  london: "Londres",
  paris: "París",
  berlin: "Berlín",
  shanghai: "Shanghái",
  new_york: "Nueva York",
  los_angeles: "Los Ángeles",
  privacy_policy: "Ver política de privacidad",
  email_placeholder: "Por favor ingrese su dirección de correo electrónico",
  empty_chart_action: "Calcular ahora",
  preview: "Vista previa",
  sign_out: "Cerrar sesión",
  invoice: "Factura",
  credit_notes: "Notas de crédito",
  filter: "Filtrar",
  trendChart: {
    export_image: "Exportar imagen",
    this_month: "Este mes",
    last_month: "Mes pasado",
    month_before_last: "Mes anterior al pasado",
    this_week: "Esta semana",
    last_2_weeks: "Últimas 2 semanas",
    last_4_weeks: "Últimas 4 semanas",
    today: "Hoy",
    yesterday: "Ayer",
    day_before_yesterday: "Anteayer",
    month: "Mes",
    week: "Semana",
    day: "Día",
    export_failed: "Error al exportar el gráfico",
    export_retry: "Error en la exportación del gráfico, por favor intente nuevamente",
  },
  view_all_news: "Ver todas las noticias",
  confirm: "Confirmar",
  rangeSearch: "Búsqueda por rango",
  leg: {
    origin: "Origen",
    destination: "Destino",
    transportMode: "Modo de transporte",
    distance: "Distancia (km)",
    weight: "Peso (t)",
    cnCode: "Código CN",
    transportEmission: "Emisión de transporte (kg CO2e)",
    productionEmission: "Emisión de producción (kg CO2e)",
    totalEmission: "Emisión total (kg CO2e)",
  },
  previewReports: {
    pdfPreview: "Vista previa PDF",
    excelPreview: "Vista previa Excel",
    payPerUse: "Límite excedido, ¿pagar por uso?",
    payPerUseDownload: "Descarga por uso",
    download: "Descargar",
    refresh: "Actualizar",
    darkModeWarning:
      "El modo oscuro solo sirve para previsualizar la interfaz de usuario y no afecta los archivos exportados. Los archivos exportados mantienen un estilo de fondo blanco",
    upgradeToUnlockExcel: "Actualice a Pro para desbloquear la vista previa de Excel",
    unlockFeatures:
      "Desbloquee la exportación de Excel, logotipo personalizado, multilingüismo y otras funciones avanzadas para mejorar la profesionalidad de los informes",
    upgradeNow: "Actualizar ahora",
    previewFailed: "Error en la vista previa",
    excelPreviewRequiresPro: "¡La vista previa de Excel requiere una suscripción Pro!",
    limitReached: "Límite diario o mensual alcanzado",
    saved: "Guardado con éxito, puede verlo en la lista de informes",
  },
  select_status: "Seleccionar estado",
  select_plan_type: "Seleccionar tipo de plan",
  refund: "Reembolso",
  view: "Ver",
  start_date: "Fecha de inicio",
  end_date: "Fecha de finalización",
  view_details: "Ver detalles",
  back_to_login: "Volver al inicio de sesión",
  view_count_description:
    "El número de vistas representa el total de accesos a este informe a través del compartir. Cancelar el compartir no reinicia este contador.",
  notify: {
    auto_renew: "Renovación automática",
    auto_renew_desc:
      "Habilite para renovar automáticamente su suscripción al final del ciclo de facturación.",
  },
  ticketTypes: {
    technical: "Problema técnico",
    billing: "Problema de facturación",
    compliance: "Consulta de cumplimiento",
    feedback: "Comentarios y sugerencias",
    other: "Otros",
  },
  loading_verification: "Cargando verificación...",
  billing: {
    current_plan: "Plan actual",
    upgrade: "Ver actualización",
    manage: "Ver facturación",
    plan_type: "Tipo de plan",
    next_billing: "Próxima fecha de facturación",
    expiry_date: "Fecha de vencimiento",
    expired: "Expirado",
    permanent: "Permanente",
  },
  faq: {
    search_placeholder: "Buscar preguntas frecuentes...",
    no_results_title: "No se encontraron resultados",
    no_results_subtitle:
      "Intente ajustar sus términos de búsqueda o explore las categorías de la izquierda.",
    search_cleared_message: "Búsqueda eliminada para mostrar contenido completo",
    still_have_questions: {
      before_email: "¿Tiene más preguntas? Contáctenos en ",
      after_email: " — nuestro equipo responderá dentro de 24 horas.",
    },
  },
};
